/**
 * The homepage bundle entry (THE FEED, design.md Part III): the shared runtime
 * plus one init per section, in page order. Called from public.ts on every
 * public page; it returns at once unless <body> is `.page-home`.
 */
import { initHome } from "./runtime";
import { init as s01 } from "./s01-cover";
import { init as s02 } from "./s02-skip";
import { init as s03 } from "./s03-never";
import { init as s04 } from "./s04-trust";
import { init as s05 } from "./s05-numbers";
import { init as s06 } from "./s06-why";
import { init as s07 } from "./s07-own";
import { init as s09 } from "./s09-how";
import { init as s10 } from "./s10-industries";
import { init as s11 } from "./s11-clients";
import { init as s12 } from "./s12-start";
import { init as s13 } from "./s13-contact";

export function initHomePage(): void {
  initHome([s01, s02, s03, s04, s05, s06, s07, s09, s10, s11, s12, s13]);
}
